import { render, staticRenderFns } from "./MdtDiseasePacs.vue?vue&type=template&id=d35c9d62&scoped=true"
import script from "./MdtDiseasePacs.vue?vue&type=script&lang=js"
export * from "./MdtDiseasePacs.vue?vue&type=script&lang=js"
import style0 from "./MdtDiseasePacs.vue?vue&type=style&index=0&id=d35c9d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35c9d62",
  null
  
)

export default component.exports